import React, { Component } from "react";
import { Navbar, Modal, Button } from "react-bootstrap";
import * as pageData from "./PageData";
const $ = window.$;

export default class PageHeader extends Component {
    constructor(props) {
        super(props);
        this.handleMenuItem = this.handleMenuItem.bind(this);
        this.playButtonClick = this.playButtonClick.bind(this);
        this.handleModalEnter = this.handleModalEnter.bind(this);
        this.handleModalVerifyPassword = this.handleModalVerifyPassword.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.state = {
            showVerifyPasswordModal: false
        };
    }

    componentDidMount() {
        const p = this.props;

        if (p.speechSupported) {
            initSpeech(p);
        }

        $(document).ready(function () {
            $("ul.dropdown-menu [data-toggle=dropdown]").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).parent().siblings().removeClass("open");
                $(this).parent().toggleClass("open");
            });
        });
    }

    handleMenuItem(e, selectedKey, id) {
        e.preventDefault();

        const p = this.props;

        switch (selectedKey) {
            case "unlock":
                this.setState({ showVerifyPasswordModal: true });
                break;
            case "devMode":
                {
                    const obj = $(".menu-item-devMode");
                    let checked;

                    if (obj.hasClass("fa-check-square")) {
                        obj.removeClass("fa-check-square").addClass("fa-square");
                        checked = false;
                    } else {
                        obj.removeClass("fa-square").addClass("fa-check-square");
                        checked = true;
                    }

                    p.setDevMode(checked);
                    break;
                }
        case "trainingMode":
            {
                const obj = $(".menu-item-trainingMode");
                let checked;

                if (obj.hasClass("fa-check-square")) {
                    obj.removeClass("fa-check-square").addClass("fa-square");
                    checked = false;
                } else {
                    obj.removeClass("fa-square").addClass("fa-check-square");
                    checked = true;
                }

                p.setTrainingMode(checked);
                break;
            }
        case "jumpTo":
            p.cancelSpeech();
            setTimeout(() => {
                p.jumpTo(id);
            }, 100);
            break;
        case "exit":
            p.cancelSpeech();
            setTimeout(() => {
                window.location.href = "/";
            }, 100);
            break;
        default:
            break;
        }
    }

    playButtonClick(type) {
        if (type === "stop" && this.props.speechPlaying) {
            this.props.cancelSpeech();
        } else if (type === "play" && !this.props.speechPlaying) {
            this.props.playSpeech();
        }
    }

    handleModalEnter() {
        try {
            $(".verify-password").focus();
        } catch (e) {
            //
        }
    }

    handleModalClose() {
        this.setState({ showVerifyPasswordModal: false });
    }

    handleModalVerifyPassword() {
        this.setState({ showVerifyPasswordModal: false });
        const password = $(".verify-password").val();
        if (password.length > 0) {
            this.props.unlock(password);
        }
    }

    render() {
        const p = this.props;

        return (
<div className="test-page-header">
    <Navbar>
        <img className="logo" src="/images/Logo_sm2.png" alt="" title="CPP" height="34" width="35" />
        {renderStepNo(p.devMode, p.step)}
        {renderControls(p.unlocked, p.allowDevMode, p.devMode, p.allowTrainingMode, p.trainingMode, p.speechSupported, p.hasSpeech, p.speechPlaying, p.speechPlayedCount, p.tests, this.handleMenuItem, this.playButtonClick)}
    </Navbar>
    <Modal onEnter={this.handleModalEnter} show={this.state.showVerifyPasswordModal} onHide={this.handleModalClose}>
        <Modal.Header closeButton>
            <Modal.Title>Unlock</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="form-horizontal">
                <div className="form-group row">
                    <label className="control-label col-sm-4">Password</label>
                    <div className="col-sm-4">
                        <input type="text" className="form-control verify-password" autoComplete="none" maxLength="20" />
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button bsStyle="default" onClick={this.handleModalClose}>No thanks</Button>
            <Button bsStyle="success" onClick={this.handleModalVerifyPassword}>Yes, I'm sure</Button>
        </Modal.Footer>
    </Modal>
</div>
        );
    }
}

function initSpeech(p) {
    const slider = $("#volume-slider").slider({
        min: 0.3,
        max: 1,
        step: 0.1,
        value: p.volume,
        tooltip: "always"
    });

    const setVolume = p.setVolume;

    slider.on("change", function (e) {
        setVolume(e.value.newValue);
    });
}

function renderStepNo(devMode, step) {
    var title = pageData.getPageTitle(step);
    if (!devMode) {
        return <div className="step-no">{title}</div>;
    }
    return <div className="step-no">{title} ({step})</div>;
}

function renderControls(unlocked, allowDevMode, devMode, allowTrainingMode, trainingMode, speechSupported, hasSpeech, speechPlaying, speechPlayedCount, tests, handleMenuItem, playButtonClick) {
    if (speechSupported) {
            return (
<div id="page-controls">
    <div>{renderReplayButtons(hasSpeech, trainingMode, speechPlaying, speechPlayedCount, playButtonClick)}</div>
    <i title="Volume" className="speech-yes fal fa-volume" />
    <input id="volume-slider" />
    {renderMenu(unlocked, allowDevMode, devMode, allowTrainingMode, trainingMode, tests, handleMenuItem)}
</div>
            );
    }

return (
<div id="page-controls">
    <i title="Speech not supported" className="speech-no fal fa-volume-slash" />
    {renderMenu()}
</div>
    );
}

function renderReplayButtons(hasSpeech, trainingMode, speechPlaying, speechPlayedCount, playButtonClick) {
    if (!hasSpeech) {
        return <div key="0" />;
    }

    return (
<React.Fragment>
    {renderReplay(speechPlaying, speechPlayedCount, playButtonClick)}
    {renderStop(trainingMode, speechPlaying, playButtonClick)}
</React.Fragment>
    );
}

function renderReplay(speechPlaying, speechPlayedCount, playButtonClick) {
    const className = `speech-play${speechPlaying || speechPlayedCount >= 2 ? " disabled" : ""}`;

    return (
<div key="1" className={className} onClick={() => playButtonClick("play")}>
    <i title="Replay" className="fal fa-play" />
</div>
    );
}

function renderStop(trainingMode, speechPlaying, playButtonClick) {
    if (!trainingMode) {
        return null;
    }

    const className = `speech-stop${speechPlaying ? "" : " disabled"}`;

    return (
<div key="2" className={className} onClick={() => playButtonClick("stop")}>
    <i title="Stop" className="fal fa-stop" />
</div>
    );
}

function renderMenu(unlocked, allowDevMode, devMode, allowTrainingMode, trainingMode, tests, handleMenuItem) {
    return (
<ul className="nav navbar-nav navbar-right">
    <li className="dropdown">
        <button className="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" data-submenu>
            <span><i className="fal fa-bars" /></span>
            <span className="caret" />
        </button>
        <ul className="dropdown-menu dropdownmenu-right">
            {renderUnlock(unlocked, devMode, handleMenuItem)}
            {renderDevModeItem(unlocked, allowDevMode, devMode, handleMenuItem)}
            {renderTrainingModeItem(unlocked, allowTrainingMode, devMode, trainingMode, handleMenuItem)}
            {renderJumpTo(unlocked, devMode, trainingMode, tests, handleMenuItem)}
            {renderDivider(unlocked, devMode)}
            {renderExit(unlocked, devMode, handleMenuItem)}
        </ul>
    </li>
</ul>
    );
}

function renderUnlock(unlocked, devMode, handleMenuItem) {
    if (!devMode && !unlocked) {
        return <li key={1}><button href="" onClick={(e) => handleMenuItem(e, "unlock")}>Unlock</button></li>;
    }
    return null;
}

function renderDevModeItem(unlocked, allowDevMode, devMode, handleMenuItem) {
    if (allowDevMode && (unlocked || devMode)) {
        const checked = devMode ? <i className="menu-item-devMode fal fa-check-square" /> : <i className="menu-item-devMode fal fa-square" />;
        return <li key={2}><button onClick={(e) => handleMenuItem(e, "devMode")}>{checked}Dev Mode</button></li>;
    }
    return null;
}

function renderTrainingModeItem(unlocked, allowTrainingMode, devMode, trainingMode, handleMenuItem) {
    if ((unlocked && allowTrainingMode) || devMode) {
        const checked = trainingMode ? <i className="menu-item-trainingMode fal fa-check-square" /> : <i className="menu-item-trainingMode fal fa-square" />;
        return <li key={3}><button onClick={(e) => handleMenuItem(e, "trainingMode")}>{checked}Training Mode</button></li>;
    }
    return null;
}

function renderJumpTo(unlocked, devMode, trainingMode, tests, handleMenuItem) {
    const arr = pageData.getJumpToMenuItems(tests);

    const menuItems = arr.map(function (elem, index) {
        return renderMenuItem(elem, index, handleMenuItem);
    });

    const className = "dropdown dropleft dropdown-submenu" + (devMode || (unlocked && trainingMode) ? "" : " hide");

    return (
        <li key={4} className={className}>
        <button className="dropdown-toggle" data-toggle="dropdown">Jump To</button>
        <ul className="dropdown-menu">
        {menuItems}
        </ul>
    </li>
        );
}

function renderMenuItem(elem, index, handleMenuItem) {
    if (elem.id === 0) {
        return <li key={index} role="separator" className="divider" />;
    }

    return <li key={index}><button className="dropdown-item" onClick={(e) => handleMenuItem(e, "jumpTo", elem.id)}>{elem.name}</button></li>;
}

function renderDivider(unlocked, devMode) {
    if (unlocked || devMode) {
        return <li key={5} role="separator" className="divider" />;
    }
    return null;
}

function renderExit(unlocked, devMode, handleMenuItem) {
    if (unlocked || devMode) {
        return <li key={6}><button href="" onClick={(e) => handleMenuItem(e, "exit")}>Exit</button></li>;
    }
    return null;
}
